import { type FC, memo } from 'react';
import Player from 'react-player';

type VideoPlayerProps = {
	source?: string;
	autoPlay?: boolean;
	className?: string;
	onVideoFinished?: () => void;
};

const VideoPlayer: FC<VideoPlayerProps> = memo(
	({ source, autoPlay = false, className, onVideoFinished }) => {
		return (
			<div className={className}>
				<Player
					className="object-cover"
					controls
					height="100%"
					muted
					onEnded={onVideoFinished}
					playing={autoPlay}
					src={source}
					width="100%"
				/>
			</div>
		);
	}
);

export default VideoPlayer;
